import { ReportGmailerrorredOutlined as ReportGmailerrorredOutlinedIcon } from '@frontierag/frontier-ui-library/icons';
import {
  ROUTE_ENVIRONMENTAL_CROPS_HOME,
  ROUTE_ENVIRONMENTAL_CROPS_ORDERS_FAILED,
} from 'appConstants';

export const envCropsMenuItems = [
  {
    icon: <ReportGmailerrorredOutlinedIcon />,
    label: 'failedOrders',
    url: `${ROUTE_ENVIRONMENTAL_CROPS_HOME}/${ROUTE_ENVIRONMENTAL_CROPS_ORDERS_FAILED}`,
  },
];
